export default __webpack_public_path__ + "static/media/cha_healer_myrrh.a87a5b1a.png";